export const orderByFn = (
    column: string,
    direction: 'asc' | 'desc',
    searchOrderBy: string,
    setOrderDirection: (direction: 'asc' | 'desc' | '') => void,
    setFilterParameter: (key: string, value: string) => void
) => {
    const sameColumn = column === searchOrderBy?.replace("-", "");
    const dir = sameColumn ? direction === 'asc' ? 'desc' : direction === 'desc' ? '' : 'asc' : 'asc';
    setOrderDirection(dir);
    setFilterParameter("ordering", !!dir ? `${dir === 'asc' ? '' : '-'}${column}` : '');
}
